import ShareMethodButton from '../ShareMethodButton';

import { shareMethods } from './config';
import useStyles from './styles';
import { IShareModal } from './types';

function ShareModal({
  toolName,
  toolUrl,
  analytics,
  setShowShareModal,
  setShowCopyInfoAlert,
}: IShareModal) {
  const classes = useStyles();
  return (
    <>
      <span className={classes.modalText}>Share this page</span>
      <span className={classes.toolName}>{toolName}</span>
      <span>{toolUrl}</span>
      <div className={classes.toolsContainer}>
        {shareMethods.map(({ icon, backgroundColor, name, value }, index) => (
          <div className={classes.shareMethodContainer} key={index}>
            <ShareMethodButton
              analytics={analytics}
              value={value}
              toolUrl={toolUrl}
              backgroundColor={backgroundColor}
              icon={icon}
              setShowCopyInfoAlert={setShowCopyInfoAlert}
              setShowShareModal={setShowShareModal}
            />
            <span className={classes.shareMethodName}>{name}</span>
          </div>
        ))}
      </div>
    </>
  );
}
export default ShareModal;
